import { Widget } from 'cc';

const originalOnEnable = Widget.prototype.onEnable;
Widget.prototype.onEnable = function onEnable(this: Widget) {
    originalOnEnable.call(this);
    this.updateAlignment();
};

export {};
